export const DATE_FORMAT = "sv"